import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { PropType, computed, inject, ref } from "vue";
import { IBookInfo } from "@/domain/entities/book";
import BookHistoryRow from "./BookHistoryRow.vue";
import InlineSvg from "vue-inline-svg";
import router from "@/router";
import {
  PROVIDE_KEY_SHOW_ERROR_MODAL,
  RouterName,
  ShowErrorModal,
} from "@/types";
import { useBookStore } from "@/stores/bookStore";
import ScrollTopControl from "../shared/ScrollTopControl.vue";


const __default__ = {
  name: "BookHistoryTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  bookInfos: {
    type: Object as PropType<IBookInfo[]>,
    required: true,
  },
  shouldShowFilterMenu: {
    type: Boolean,
    default: false,
  },
  filterDisplayText: {
    type: String,
    default: "",
  },
},
  emits: ["onClickFilter", "onSelectBookInfo"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "4973916e-filterMenuHeight": (filterMenuHeight.value)
}))

const props = __props;

const emit = __emit;

const bookStore = useBookStore();

const bookHistoryContentRef = ref<HTMLElement>();

const showErrorModal = inject(PROVIDE_KEY_SHOW_ERROR_MODAL) as ShowErrorModal;

const emitOnClickFilter = () => {
  emit("onClickFilter");
};

const emitOnSelectBookInfo = (bookInfo: IBookInfo) => {
  emit("onSelectBookInfo", bookInfo);
};

const getBookInfoDetail = async (bookInfo: IBookInfo) => {
  const bookInfoDetailResult = await bookStore.getBookInfoDetail(
    bookInfo.id,
    bookInfo.bookDetailId
  );
  if (!bookInfoDetailResult.isSuccess) {
    showErrorModal(
      "예약상세 오류",
      bookInfoDetailResult.errorMessage,
      bookInfoDetailResult.resultCode,
      bookInfoDetailResult.errorTime
    );
    return;
  }

  if (!bookInfoDetailResult?.data) return;

  emitOnSelectBookInfo(bookInfoDetailResult.data);
};

/** 페이지 이동 */
const goToLineSearch = () => {
  router.push({ name: RouterName.LineSearch });
};

const filterMenuHeight = computed(() =>
  props.shouldShowFilterMenu ? "42px" : "0px"
);

const __returned__ = { props, emit, bookStore, bookHistoryContentRef, showErrorModal, emitOnClickFilter, emitOnSelectBookInfo, getBookInfoDetail, goToLineSearch, filterMenuHeight, BookHistoryRow, get InlineSvg() { return InlineSvg }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})